/** תצוגת סיכום חיפוש טיסות — ללא לוגיקת payload; רק תוויות ל־UI */

/** יעד ראשון לתצוגה (מערך מיקומים או אובייקט יחיד) */
export function primaryLocation(loc) {
  if (Array.isArray(loc) && loc.length > 0) return loc[0];
  return loc;
}

export function formatLocationLabel(loc) {
  if (!loc) return "—";
  return (
    loc.CITYNAME ||
    loc.AIRPORTNAME ||
    loc.AIRPORTCODE ||
    loc.name ||
    "—"
  );
}

export function summarizeRoomCompositions(roomInfo) {
  const rooms = roomInfo?.rooms;
  if (!Array.isArray(rooms) || rooms.length === 0) return "—";
  let adults = 0;
  let kids = 0;
  let infants = 0;
  for (const r of rooms) {
    adults += Number(r?.adults) || 0;
    kids += Number(r?.kids) || 0;
    infants += Number(r?.infants) || 0;
  }
  const parts = [];
  if (adults) parts.push(`${adults} מבוגרים`);
  if (kids) parts.push(`${kids} ילדים`);
  if (infants) parts.push(`${infants} תינוקות`);
  return parts.length ? parts.join(", ") : "—";
}

export function buildPlanesSearchSummary({
  origin,
  location,
  calendarDateArrival,
  calendarDateLeave,
  roomInfo,
}) {
  const dest = primaryLocation(location);
  return {
    originLabel: formatLocationLabel(origin),
    destinationLabel: formatLocationLabel(dest || location),
    departureDate: calendarDateArrival || "—",
    returnDate: calendarDateLeave || "—",
    passengersLabel: summarizeRoomCompositions(roomInfo),
  };
}
